
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MultipleFilesAttachments = (function () {

    function MultipleFilesAttachments () {

        Monet.UI.Fields.MultipleImageUpload.apply(this, arguments);


        this.renderImageBox = (imageData, id, fullFileName) => {
            const container = document.createElement('div');
            const fileNameEl = document.createElement('span');
            const deleteImage = document.createElement('span');
            const downloadBtnEl = document.createElement('span');
            const image = document.createElement('img');

            fileNameEl.className = 'file-box__name';
            const fileName = fullFileName.split('/').pop();
            const fileNameShort = fileName.replace(/(.{22})..+/, "$1…");
            fileNameEl.textContent = fileNameShort;
            fileNameEl.setAttribute('title', fileName);
  
            deleteImage.className = 'button-delete';
            deleteImage.setAttribute('aria-label', Monet.I18n.getResourcesByKey("TaskManager.attachmentsSection.deleteBtn.label"));
            deleteImage.setAttribute('title', Monet.I18n.getResourcesByKey("TaskManager.attachmentsSection.deleteBtn.label"));
            deleteImage.setAttribute('id', id);
            deleteImage.onclick = this.deleteImage.bind(this);

            if(!imageData) {
                downloadBtnEl.className = 'button-download';
                downloadBtnEl.setAttribute('aria-label', Monet.I18n.getResourcesByKey("TaskManager.attachmentsSection.downloadBtn.label"));
                downloadBtnEl.setAttribute('title', Monet.I18n.getResourcesByKey("TaskManager.attachmentsSection.downloadBtn.label"));
                downloadBtnEl.setAttribute('id', id);
                downloadBtnEl.onclick = this.downloadFile;
            }

            image.src = require("static/images/task/file-icon.png");
  
            container.className = 'file-box';
            container.appendChild(image);
            container.appendChild(fileNameEl);
            container.appendChild(downloadBtnEl); 
            container.appendChild(deleteImage); 
  
            return container;  
        };

        this.downloadFile = (event) => {
            event.stopPropagation();
            event.preventDefault();
            const id = event.target.getAttribute('id');
            const file = this.uploadedImages.get(id);

            if(file?.info?.id) {
                try {

                    new Function(
                      'fileId',
                      this.meta.actionDownload
                    )(file.info.id);
                    
                  } catch (error) {
                    new Monet.Exception.ReturnError(this, "Maybe you need to add meta.actionDownload function to this field.")
                      .console();
                  }
              } else {
                  new Monet.Exception.ReturnError(this, "No File ID found.")
                      .console();
              }
        };

        this.handlerRenderImages = data => {
            if (data?.length) {
                data.forEach( file => {
                    this.addImage(null, file, file.fileName);
                });
            }
        };

        this.validateFileFormats = (file) => {
            const hasFileAExtension = () => {
                const fileName = file.name;
                const splitedByDot = fileName && fileName.split('.');
                const checkIfHasContentAfterDot = splitedByDot && splitedByDot.length > 1;
                const lastItemFromSplitedByDot = checkIfHasContentAfterDot && splitedByDot.pop();
                const hasAExtension = lastItemFromSplitedByDot && (lastItemFromSplitedByDot.length === 3 || lastItemFromSplitedByDot.length === 4);
                
                return hasAExtension;
            };

            if(this.fileFormats.length === 0) {
                //para validar todos os tipos de arquivos
                return hasFileAExtension();
            } else {
                return (file &&
                        file.name.match(new RegExp("^.*\.(" + this.fileFormats.join("|") + ")")));
            }
        };

        this._removeErrorStyleFromContainer = () => {
            this.imageContainer.classList.remove("error");
        };
    }

    return MultipleFilesAttachments;

}());